/**
 * RecordingIndicator Komponente
 * Zeigt an, dass eine Aufnahme läuft (roter pulsierender Punkt)
 */

import { memo } from 'react';

interface RecordingIndicatorProps {
  label?: string;
  className?: string;
}

export const RecordingIndicator = memo(function RecordingIndicator({
  label = 'Aufnahme',
  className = '',
}: RecordingIndicatorProps) {
  return (
    <div
      className={`flex items-center gap-2 px-3 py-1.5 bg-red-50 border border-red-200 rounded-full ${className}`}
      role="status"
      aria-live="polite"
    >
      <div
        className="w-2.5 h-2.5 bg-red-500 rounded-full animate-pulse"
        aria-hidden="true"
      />
      <span className="text-xs font-medium text-red-700">{label}</span>
    </div>
  );
});

export default RecordingIndicator;
